import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute(
  "/_auth/_coach/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/submissions",
)({
  validateSearch: z.object({
    tab: z.enum(["list", "response"]).default("list"),
  }),
  search: { middlewares: [stripSearchParams({ tab: "list" })] },
});
